import Service from '@/service/index'
import { handleBanner } from '@/common/utils/map_view_data'

const viewLog = (data) => {
    data.forEach((item, i) => {
        Service.interestingEvent({
            interesting_id: item.id,
            event: 'view',
            pos: i,
            pos_name: item.position
        })
    })
    return data
}

const resolveData = (key, limit) => {
    return Service.getRecommendation(key, limit).then((data) => {
        return data
    })
}

let hot_search = null

const DEFAULT_PLACEHOLDER = '按楼盘名字搜索'

export default {
    getKeyword () {
        return resolveData('hot_search_keyword', 4)
    },
    getList () {
        return resolveData('hot_search_list', 5).then(viewLog).then(handleBanner)
    },
    clickHotSearch (item) {
        hot_search = item
    },
    getHotSearch () {
        return hot_search
    }
}
